import * as React from 'react';
import {FtIcons} from "@/FtIcons";
import {useEffect} from "react";

interface Props {
    title?: string;
    handleClose: () => void;
    children?: React.ReactNode;
    minWidth?: string | number;
}

export function FtDialog(props: Props) {
    useEffect(() => {
        function onKeyDown(e: KeyboardEvent) {
            if (e.key === 'Escape') {
                props.handleClose();
            }
        }

        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        }
    }, []);

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <div style={{
                backgroundColor: "white",
                minWidth: props.minWidth || "300px",
                boxSizing: "border-box",
                padding: "20px",
                borderRadius: "4px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            }}>
                {props.title && <FtDialogTitle title={props.title} handleClose={props.handleClose}/>}
                {props.children}
            </div>
        </div>
    )
}

export function FtDialogTitle({title, handleClose}: { title?: string, handleClose: () => void }) {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
            }}
        >
            <div style={{
                fontSize: "1.2rem",
                fontWeight: "bold",
            }}>{title}</div>

            <button onClick={handleClose}
                    style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#007bff",
                        cursor: "pointer",
                    }}>
                {FtIcons.close}
            </button>
        </div>
    );
}